import {
  Checkbox,
  FormControlLabel,
  createStyles, makeStyles, Theme, Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

interface IAgreeSection {
  setIsButtonNextDisable: React.Dispatch<React.SetStateAction<boolean>>
  note?: string
}

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const renderWithLinks = (text: string): React.ReactNode[] => {
  const parts = text.split(URL_REGEX);
  return parts.map((part, index) => {
    if (part.match(/^https?:\/\//)) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <a key={`link-${index}`} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    // eslint-disable-next-line react/no-array-index-key
    return <React.Fragment key={`text-${index}`}>{part}</React.Fragment>;
  });
};

const AgreeSection : React.FC<IAgreeSection> = ({ setIsButtonNextDisable, note }) => {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setIsButtonNextDisable(!event.target.checked);
  };

  const hasNote = !!note && note.trim().length > 0;

  return (
    <div className={classes.sectionContainer}>
      <Typography variant="h6" className={classes.precautionTitle}>お申込み前のご注意</Typography>
      {hasNote && (
        <div className={classes.precautionBox}>
          <p className={classes.precautionText}>
            {renderWithLinks(note || '')}
          </p>
        </div>
      )}
      <div>
        <span className={clsx(classes.badge, classes.isShowBadge2)}>必須</span>
        <FormControlLabel
          control={(
            <Checkbox
              checked={checked}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          )}
          label={(
            <span className={classes.agreeDesc2}>
              上記お申込み前のご注意および個人情報保護方針を確認の上、同意します。
            </span>
          )}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  sectionContainer: {
    marginBottom: '29px',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#EBEBEB',
    flexDirection: 'column',
    paddingTop: '40px',
    paddingBottom: '30px',
  },
  precautionTitle: {
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '16px',
    alignSelf: 'flex-start',
    paddingLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  precautionBox: {
    width: '90%',
    backgroundColor: '#fff',
    borderLeft: '4px solid #CD0021',
    padding: '16px 20px',
    marginBottom: '24px',
    fontSize: '14px',
    lineHeight: '1.8',
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      fontSize: '12px',
    },
  },
  precautionText: {
    margin: '0 0 12px 0',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    '&:last-child': {
      margin: 0,
    },
  },
  badge: {
    fontSize: '14px',
    lineHeight: '21px',
    color: '#ffffff',
    backgroundColor: '#d0111b',
    marginRight: '30px',
  },
  agreeDesc2: {
    fontSize: '19px',
    lineHeight: '29px',
    textAlign: 'center',
    color: '#1a1a1a',
  },
  isShowBadge2: {
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export default AgreeSection;
